'use strict'

/**
 * Исправляет проблемы со скроллом в каталоге товаров который работает в режиме ajax.
 */
class Ajax {
    static lastPositionX = 0
    static lastPositionY = 0

    static setPosition() {
        this.lastPositionX = scrollX
        this.lastPositionY = scrollY
    }

    static async closeAllPopupAndFilter() {
        // Обозначаем функцию как асинхронную с помощью ключевого слова async
        return new Promise((resolve, reject) => {
            try {
                $('*').popup('hide');
                $('[id*=_background]').css({
                    'opacity': 0,
                    'visibility': 'hidden'
                });
                $('.popup_wrapper > .popup.popup_content').css({
                    'opacity': 0,
                    'visibility': 'hidden',
                    'display': 'none',
                });

                document.body.style.overflow = 'auto';

                if (typeof filter !== 'undefined') {
                    filter.closeAllProperty();
                    filter.closeAllTabs();
                }

                // Разрешаем промис после успешного выполнения
                resolve();
            } catch (error) {
                // Отклоняем промис в случае ошибки
                reject(error);
            }
        });
    }

    // Возвращает позицию скролла после ajax перехода
    static goToPosition() {
        this.closeAllPopupAndFilter()
        scroll(this.lastPositionX, this.lastPositionY)
    }

    /**
     * Скролл страницы вверх когда делается переход по постраничной навигации
     * @param url
     */
    static pageNavigationInsertToNode(url) {
        let node = BX.ajax.history.obParams.node
        url += '?bxajaxid=' + this.removeComp(node)
        let xhr = BX.ajax.insertToNode(url, node)
        xhr.onload = () => {
            window.scroll(0, 0)
        }
    }

    // /**
    //  * Замена стандартному BX.ajax.insertToNode с обновлением истории страницы.
    //  * Нужно для того что бы при нажатии в браузере кнопки "Назад" страница открылась на том же месте и
    //  * с теми же элементами, даже теми которые были подгружены ajax.
    //  * @param event
    //  * @param url
    //  */
    // static insertToNode(event, url) {
    //     event.preventDefault()
    //     this.closeAllPopupAndFilter()
    //
    //     let node = BX.ajax.history.obParams.node
    //
    //     // Записывает позицию скролла до ajax перехода
    //     this.setPosition()
    //
    //     BX.ajax.history.startState.data = BX(node).innerHTML
    //
    //     url += '?bxajaxid=' + this.removeComp(node)
    //     let xhr = BX.ajax.insertToNode(url, node)
    //     xhr.onload = () => {
    //         sessionStorage.setItem('catalog-ajax_scroll-recording-disable', location.href)
    //     }
    //
    // }

    // Функция для удаления подстроки "comp_" из строки
    static removeComp(str) {
        // Проверяем, что строка начинается с "comp_"
        if (str.startsWith('comp_')) {
            // Возвращаем строку без первых пяти символов
            return str.slice(5)
        } else {
            // Возвращаем строку без изменений
            return str
        }
    }
}
window.TimeCity = window.TimeCity || {};
window.TimeCity.Ajax = Ajax;